module.exports = __webpack_public_path__ + "img/13_icon_dimmed.69ce65fe.svg";